<template>
  <div class="dataScreenMap-box">
    <div v-if="mapLevel === 2" class="back-box" @click="handleBack">返回上一级</div>
    <div v-if="mapLevel === 2" class="markerSelect">
      <div class="markerSelect-top">图例</div>
      <div class="list">
        <div class="select-box" :class="{active : markerTypes.indexOf(0) !== -1}" @click="changeMarkerType(0)"></div>
        <div>
          <img src="../assets/monitor.png">
          <div style="color: #0E27F7;text-align: center">在线</div>
        </div>
      </div>
      <div class="list">
        <div class="select-box" :class="{active : markerTypes.indexOf(1) !== -1}" @click="changeMarkerType(1)"></div>
        <div>
          <img src="../assets/monitor-warning.png">
          <div style="color: #F9461B;text-align: center">离线</div>
        </div>
      </div>
      <div class="list">
        <div class="select-box" :class="{active : markerTypes.indexOf(2) !== -1}" @click="changeMarkerType(2)"></div>
        <div>
          <img src="../assets/fire.png">
        </div>
      </div>
    </div>
    <div v-if="mapLevel === 2" id="tooltip-box">
      <img class="close" src="../assets/close.png" @click="closeTooltip">
      <div class="tooltip-title"></div>
      <el-carousel indicator-position="outside">
        <el-carousel-item>
          <div class="tooltip-con">
            <div class="tip-box">
              负责人：{{ monitor.gridName }}
              <span style="margin-left: 10px">联系电话：{{ monitor.gridTel }}</span>
            </div>
            <div class="img-box"><el-image class="img" :src="monitor.eventImg"></el-image></div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="tooltip-con">
            <div class="tip-box">
              负责人：{{ monitor.gridName }}
              <span style="margin-left: 10px">联系电话：{{ monitor.gridTel }}</span>
            </div>
            <div class="img-box"><el-image class="img" :src="monitor.eventImg1"></el-image></div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div id="dataScreenMap" v-loading="loading" element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0)"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import 'echarts/lib/component/tooltip'
import anci from "../mapData/hebei.tianditu.gov.cn1.json"
import { getFireMapPoints, getFireMapPointDetail } from "../../../../api/dataScreen";
import GCJ02_WGS84 from "../../../../utils/changeMap";
export default {
  name: "DataScreenMap",
  data () {
    return {
      charts: null,
      loading: false,
      mapLevel: 1,
      mapWarning: {
        "001": 3,
        "002": 2,
        "003": 12,
        "004": 10,
        "005": 12,
        "006": 12,
        "007": 15,
        "008": 12,
        "009": 9
      },
      tooltipList: [],
      monitor: {
        deviceName: '',
        pointWarningData: []
      },
      timer: null,
      activeTown: {},
      markerTypes: [0,1,2]
    }
  },
  mounted() {
    this.getFireMapPoints()
    this.timer = setInterval(() => {
      if (this.mapLevel === 1) {
        this.getFireMapPoints()
      } else if (this.mapLevel === 2) {
        this.getFireMapPointDetail(this.activeTown.town, this.activeTown.layer)
      }
    },600000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getFireMapPoints () {
      this.loading = true
      getFireMapPoints().then(res => {
        this.loading = false
        this.mapWarning = res.data
        this.initCharts()
      }).catch(() => {
        this.loading = false
      })
    },
    initCharts() {
      if (this.charts !== null) {
        this.charts.off('click')
        this.charts.clear()
      }
      this.mapLevel = 1
      const xz_icon = 'image://' + require('../assets/xz-icon.png')
      const xz_w_icon = 'image://' + require('../assets/xz_w_icon.png')
      this.charts = echarts.init(document.getElementById('dataScreenMap'))
      const serviceData = [
        { name: "北史家务乡监测站点", value: [116.712914, 39.503905, this.mapWarning['001']], layer: '7', town: '001' },
        { name: "龙河高新区", value: [116.712914, 39.483905, this.mapWarning['002']], layer: '7', town: '002' },
        { name: "杨税务监测站点", value: [116.641846, 39.458728, this.mapWarning['003']], layer: '9', town: '003' },
        { name: "仇庄乡监测站点", value: [116.729050, 39.406038, this.mapWarning['005']], layer: '5', town: '005' },
        { name: "落垡镇监测站点", value: [116.791878, 39.427099, this.mapWarning['004']], layer: '10', town: '004' },
        { name: "码头镇监测站点", value: [116.793251, 39.315441, this.mapWarning['006']], layer: '3', town: '006' },
        { name: "调河头乡监测站点", value: [116.706905, 39.276251, this.mapWarning['009']], layer: '2', town: '009' },
        { name: "葛渔城镇监测站点", value: [116.802864, 39.241322, this.mapWarning['007']], layer: '4', town: '007' },
        { name: "东沽港镇监测站点", value: [116.808744, 39.176784, this.mapWarning['008']], layer: '6', town: '008' }
      ]
      const option = {
        // 提示浮窗样式
        tooltip: {
          show: false
        },
        // 地图配置
        geo: {
          map: "anci",
          roam: true,
          zoom: 1.1,
          center: undefined, // 设置为 undefined 后它内部估计会根据当前地图重新设置 center 的经纬度
          label: {
            // 通常状态下的样式
            normal: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
            // 鼠标放上去的样式
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },
          // 地图区域的样式设置
          itemStyle: {
            normal: {
              borderColor: "#1BE2F2",
              borderWidth: 2,
              color: 'rgba(0,38,90,0.2)'
            },
            // 鼠标放上去高亮的样式
            emphasis: {
              color: "rgba(0,38,90,0.2)"
            },
          },
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo",
            symbol: xz_icon,
            legendHoverLink: true,
            symbolSize: [35, 40],
            // 这里渲染标志里的内容以及样式
            label: {
              show: true,
              formatter(value) {
                return `\n\n\n{a|${value.data.name}}`
              },
              offset: [0, 15],
              rich: {
                a: {
                  color: "#00FFEE",
                  verticalAlign: 'bottom',
                  fontSize: 14,
                  fontWeight: 500
                },
                b: {
                  verticalAlign: 'top',
                  color: '#FFFFFF',
                  align: 'center',
                }
              },
            },
            data: serviceData.filter(x => { return x.value[2] === 0 }),
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            zlevel: 1,
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            symbol: xz_w_icon,
            legendHoverLink: true,
            symbolSize: [35, 40],
            // 这里渲染标志里的内容以及样式
            label: {
              show: true,
              formatter(value) {
                return `{b|${value.data.value[2]}\n\n\n} {a|${value.data.name}}`
              },
              offset: [0, 15],
              rich: {
                a: {
                  color: "#FF3D00",
                  verticalAlign: 'bottom',
                  fontSize: 14,
                  fontWeight: 500
                },
                b: {
                  verticalAlign: 'top',
                  color: '#FFFFFF',
                  align: 'center',
                }
              },
            },
            data: serviceData.filter(x => { return x.value[2] > 0 }),
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            zlevel: 1,
          }
        ]
      };
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      echarts.registerMap("anci", anci)
      this.charts.on('click', (params) => {
        try {
          if (params.data.layer) {
            this.getFireMapPointDetail(params.data.town, params.data.layer)
          }
        } catch (r) {
          this.closeTooltip()
        }
      });
      this.charts.setOption(option);
      window.addEventListener('resize', () => {
        this.charts.resize()
      })
    },
    getFireMapPointDetail (town, layer) {
      this.loading = true
      this.mapLevel = 2
      this.activeTown = { town: town, layer: layer }
      getFireMapPointDetail({town}).then(res => {
        res.data.pointsInfo.forEach(x => {
          const coordinate = GCJ02_WGS84.gcj02towgs84(Number(x.lng), Number(x.lat))
          x.lat = coordinate[1]
          x.lng = coordinate[0]
        })
        res.data.warningData.forEach(x => {
          const coordinate = GCJ02_WGS84.gcj02towgs84(Number(x.lng), Number(x.lat))
          x.lat = coordinate[1]
          x.lng = coordinate[0]
        })
        this.loading = false
        this.drawXZChart(layer, res.data)
      }).catch(() => {
        this.loading = false
      })
    },
    getMarkerList (monitorList) {
      let obj = { normalList: [], warningList: [], fireList: []}
      if (this.markerTypes.indexOf(0) !== -1) {
        monitorList.pointsInfo.forEach(item => {
          if (item.deviceStatus === 1) {
            obj.normalList.push({ name: item.deviceName, value: [item.lng, item.lat, item.warningCounts]})
          }
        })
      }
      if (this.markerTypes.indexOf(1) !== -1) {
        monitorList.pointsInfo.forEach(item => {
          if (item.deviceStatus === 0) {
            obj.warningList.push({ name: item.deviceName, value: [item.lng, item.lat, item.warningCounts]})
          }
        })
      }
      if (this.markerTypes.indexOf(2) !== -1) {
        monitorList.warningData.forEach(item => {
          obj.fireList.push({value: [item.lng, item.lat], gridName: item.gridName, gridTel:item.gridTel, eventImg: item.eventImg, eventImg1: item.eventImg1, click: true})
        })
      }
      return obj
    },
    drawXZChart (layer, monitorList) {
      if (this.charts !== null) {
        this.charts.off('click')
        this.charts.clear()
      }
      const mapData = {
        "type": "FeatureCollection",
        "name": "AreaCity-Polygon",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        "features": anci.features.filter(x => {
          return x.properties.layer === layer
        })
      }
      const monitor_icon = 'image://' + require('../assets/monitor.png')
      const monitor_w_icon = 'image://' + require('../assets/monitor-warning.png')
      const fireicon = 'image://' + require('../assets/fire.png')
      this.charts = echarts.init(document.getElementById('dataScreenMap'))
      const markerObj = this.getMarkerList(monitorList)
      const normalList = markerObj.normalList
      const warningList = markerObj.warningList
      const fireList = markerObj.fireList
      console.log(fireList)
      const option = {
        // 提示浮窗样式
        tooltip: {
          show: false
        },
        // 地图配置
        geo: {
          map: "mapData",
          roam: true,
          zoom: 1.1,
          center: undefined, // 设置为 undefined 后它内部估计会根据当前地图重新设置 center 的经纬度
          label: {
            // 通常状态下的样式
            normal: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
            // 鼠标放上去的样式
            emphasis: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
          },
          // 地图区域的样式设置
          itemStyle: {
            normal: {
              borderColor: "#1BE2F2",
              borderWidth: 2,
              color: 'rgba(0,38,90,0.2)'
            },
            // 鼠标放上去高亮的样式
            emphasis: {
              color: "rgba(0,38,90,0.2)"
            },
          },
        },
        series: [
          {
            // 提示浮窗样式
            tooltip: {
              show: false
            },
            type: "scatter",
            coordinateSystem: "geo",
            symbol: monitor_icon,
            legendHoverLink: true,
            symbolSize: [26, 26],
            // 这里渲染标志里的内容以及样式
            label: {
              show: true,
              formatter: (value) => {
                return `{a|\n${value.data.name}}`
              },
              offset: [0, 15],
              rich: {
                a: {
                  color: "#0E27F7",
                  verticalAlign: 'bottom',
                  fontSize: 12,
                  fontWeight: 500
                }
              },
            },
            // 数据格式，其中name,value是必要的，value的前两个值是数据点的经纬度，其他的数据格式可以自定义
            // 至于如何展示，完全是靠上面的formatter来自己定义的
            data: normalList,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            zlevel: 1,
          },
          {
            // 提示浮窗样式
            tooltip: {
              show: false
            },
            type: "scatter",
            coordinateSystem: "geo",
            symbol: monitor_w_icon,
            legendHoverLink: true,
            symbolSize: [26, 26],
            // 这里渲染标志里的内容以及样式
            label: {
              show: true,
              formatter: (value) => {
                return `{a|\n${value.data.name}}`
              },
              offset: [0, 15],
              rich: {
                a: {
                  color: "#F9461B",
                  verticalAlign: 'bottom',
                  fontSize: 12,
                  fontWeight: 500
                }
              },
            },
            // 数据格式，其中name,value是必要的，value的前两个值是数据点的经纬度，其他的数据格式可以自定义
            // 至于如何展示，完全是靠上面的formatter来自己定义的
            data: warningList,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            zlevel: 1,
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            symbol: fireicon,
            legendHoverLink: true,
            symbolSize: [26, 26],
            data: fireList,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            zlevel: 1,
          }
        ]
      };
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      echarts.registerMap("mapData", mapData)
      this.charts.setOption(option);
      this.charts.on('click', (params) => {
        this.closeTooltip()
        if (params.data.click) {
          this.monitor = params.data
          const dom = document.getElementById('tooltip-box')
          dom.style.left = params.event.offsetX + 20 + 'px'
          dom.style.top = this.getMarkerY(params.event.offsetY) + 'px'
        }
      });
      this.charts.on("georoam", (params) => {
        if (params.zoom || params.dx !== 0) {
          this.closeTooltip()
        }
      });
      window.addEventListener('resize', () => {
        this.charts.resize()
        this.closeTooltip()
      })
    },
    handleBack () {
      this.charts.clear()
      this.initCharts()
    },
    closeTooltip () {
      const dom = document.getElementById('tooltip-box')
      dom.style.left = '-500px'
    },
    getMarkerY (y) {
      const height = document.getElementById('dataScreenMap').offsetHeight
      if ((y + 190) > height) {
        return height - 190
      }
      return y
    },
    changeMarkerType (i) {
      if (this.markerTypes.indexOf(i) === -1) {
        this.markerTypes.push(i)
      } else {
        this.markerTypes.splice(this.markerTypes.indexOf(i), 1)
      }
      this.getFireMapPointDetail(this.activeTown.town, this.activeTown.layer)
    }
  }
}
</script>

<style scoped lang="less">
#tooltip-box{
  height: 180px;
  width: 260px;
  background-image: url("../assets/tooltip-box.png");
  background-size: 100% 100%;
  position: absolute;
  top: 100px;
  left: -500px;
  z-index: 9;
  .close{
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  /deep/.el-carousel__container{
    height: 140px;
  }
  /deep/.el-carousel__button{
    width: 2px;
  }
  /deep/.el-carousel__indicator--horizontal{
    padding: 12px 2px;
  }
  .tooltip-title{
    color: #FFFFFF;
    height: 20px;
    line-height: 28px;
    font-size: 13px;
    padding-left: 20px;
  }
  .tooltip-con{
    padding: 0 11px;
    .tip-box{
      font-size: 12px;
      line-height: 28px;
      white-space: nowrap;
    }
    .img-box{
      height: 120px;
      .img{
        width: 100%;
        height: 100%;
      }
    }
  }

}
.dataScreenMap-box{
  width: 100%;
  height: 100%;
  position: relative;
  .back-box{
    position: absolute;
    top: 10px;
    left: 550px;
    width: 140px;
    height: 43px;
    background-image: url("../assets/back-box.png");
    background-size: 100% 100%;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    line-height: 43px;
    cursor: pointer;
    z-index: 9;
  }
  .markerSelect{
    position: absolute;
    top: 10px;
    right: 550px;
    width: 134px;
    height: 256px;
    background-image: url("../assets/markerSelect.png");
    background-size: 100% 100%;
    z-index: 9;
    .markerSelect-top{
      height: 40px;
      font-size: 20px;
      color: #FFFFFF;
      align-items: center;
      display: flex;
      padding-left: 20px;
      //padding-bottom: 10px;
      &:before{
        content: '';
        display: block;
        width: 4px;
        height: 20px;
        background: #1890FF;
        margin-right: 5px;
      }
    }
    .list{
      display: flex;
      padding-left: 20px;
      padding-top: 10px;
      .select-box{
        margin-top: 20px;
        background-image: url("../assets/select.png");
        background-size: 100% 100%;
        width: 18px;
        height: 18px;
        margin-right: 5px;
        cursor: pointer;
      }
      .active{
        background-image: url("../assets/select-active.png");
      }
    }
  }
  #dataScreenMap{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}

</style>
